import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle, 
  TextContent, HighlightText, 
  JsonCodeStyle,
} from '../../../Shared';
import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listQueryParams = [
  createData('slat','number', 'start latitude'),
  createData('slng','number', 'start longitude'),
  createData('type','string', 'distance or time'),
  createData('elat','number', 'end latitude'),
  createData('elng','number', 'end longitude'),
];

const Direct = props => {
  const classes = useTableStyles();

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": [
      {
        "_id": "5f8bc32efd75bf3cf2b19275",
        "distance": 24333,
        "time": 148.75780000000012,
        "coords": [
          {
            "lat": 10.875529,
            "lng": 106.799825,
            "elat": 10.875436,
            "elng": 106.7997647,
            "segment_id": 45855,
            "status": {
              "velocity": 10,
              "source": "base-data",
              "street_type": "",
              "max_capacity": 20,
              "current_path": 0,
              "color": "#ff9900"
            }
          },
          {
            "lat": 10.8754034,
            "lng": 106.7998151,
            "elat": 10.8754964,
            "elng": 106.7998754,
            "segment_id": 45856,
            "status": {
              "velocity": 10,
              "source": "base-data",
              "street_type": "",
              "max_capacity": 20,
              "current_path": 0,
              "color": "#ff9900"
            }
          }
          //.........
        ]
      }
    ]
  }
  
  const responseErrors = {
    "code": 400,
    "message": "Bad input parameter",
    "errors": [
      {
        "reason": "invalid",
        "message": "Latitude: [-90,90]",
        "domain": "lat"
      }
    ],
    "debugError": {}
  }

  return (
    <div>
      <MainTitle>Direct</MainTitle>
      <TextContent>Direct from start position to destination position</TextContent>
      <Subtitle id="request-direct">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/segment/direct</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>
      <TextContent><b><i>Query params:</i></b></TextContent>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listQueryParams.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{row.type}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-direct">Response</Subtitle>
      <Subtitle isSmall id="success-direct">Success</Subtitle>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/segment/direct?slat=10.8755274&slng=106.799116&type=distance&elat=10.7726083&elng=106.6555093</HighlightText> </TextContent>
      <JsonCodeStyle data={responseSuccess} />

      <Subtitle isSmall id="success-direct">Errors</Subtitle>
      <TextContent>Bad input parameter</TextContent>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/segment/direct?slat=110.8755274&slng=106.799116&type=distance&elat=10.7726083&elng=106.6555093</HighlightText> </TextContent>
      <JsonCodeStyle data={responseErrors} />

      <StyledSeparated />
    </div>
  )
}

Direct.propTypes = {

}

export default Direct
